import {
  Text,
  VStack,
  Flex,
  Img,
  useColorModeValue,
  HStack,
} from "@chakra-ui/react";
import { formatDate } from "lib/utils";

export const CreatedAt = ({ date }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <VStack align="start" spacing={0}>
      <Text fontSize="md" color={textColor}>
        {date ? formatDate(date, "MMM DD, YYYY") : "-"}
      </Text>
      <Text fontSize="sm" color="gray.400" fontWeight="normal">
        {date ? formatDate(date, "HH:mm a") : "-"}
      </Text>
    </VStack>
  );
};

export const Basic = ({ text, ...props }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Text fontSize="md" color={textColor} whiteSpace="normal" {...props}>
      {text || "-"}
    </Text>
  );
};

export const Title = ({ title }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Text
      minW="200px"
      fontSize="md"
      color={textColor}
      fontWeight="bold"
      whiteSpace="normal"
    >
      {title || "-"}
    </Text>
  );
};

export const Team = ({ name, logo }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <HStack align="start" spacing={0} maxW="200px" alignItems="center">
      {logo && (
        <Img
          src={logo}
          w="40px"
          h="40px"
          borderRadius="12px"
          alt={name}
          mr="5px"
        />
      )}
      <Text fontSize="md" color={textColor} whiteSpace="normal">
        {name}
      </Text>
    </HStack>
  );
};

export const ContactName = ({ name, email }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <VStack align="start" spacing={0} maxW="200px" al>
      {name && (
        <Text
          fontSize="md"
          color={textColor}
          fontWeight="bold"
          whiteSpace="normal"
        >
          {name}
        </Text>
      )}
      {email && (
        <Text
          fontSize="sm"
          color="gray.400"
          fontWeight="normal"
          whiteSpace="normal"
        >
          {email}
        </Text>
      )}
    </VStack>
  );
};

export const UserName = ({ name, email, team, logo }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <VStack align="start" spacing={0} maxW="200px" al>
      {name && (
        <Text
          fontSize="md"
          color={textColor}
          fontWeight="bold"
          whiteSpace="normal"
        >
          {name}
        </Text>
      )}

      {email && (
        <Text
          fontSize="sm"
          color="gray.400"
          fontWeight="normal"
          whiteSpace="normal"
        >
          {email}
        </Text>
      )}

      <HStack spacing={1}>
        {logo && (
          <Img src={logo} w="20px" h="20px" borderRadius="12px" alt={name} />
        )}
        {team?.name && (
          <Text
            fontSize="sm"
            color={textColor}
            fontWeight="normal"
            whiteSpace="normal"
          >
            {team?.league === "NFLPA"
              ? "-"
              : team?.city
              ? `${team?.city} ${team?.name}`
              : "-"}
          </Text>
        )}
      </HStack>
    </VStack>
  );
};
